import { ComingSoon } from '../components/ComingSoon';

export const Dashboard = () => {
  return <ComingSoon title="Dashboard" message="Your dashboard is coming soon." />;
};
